import createActionType from "../../utils/createActionType";

export const MODULE = "pdf-customisation/editor";

export const SET_IS_FETCHING_TEMPLATE_STATUS = createActionType(
  MODULE,
  "setIsFetchingTemplateStatus"
);

export const SET_IS_SAVING_TEMPLATE_STATUS = createActionType(MODULE, "setIsSavingTemplateStatus");

export const SET_TEMPLATE = createActionType(MODULE, "setTemplate");

export const RESET = createActionType(MODULE, "reset");
